export default "__VITE_ASSET__nVN4nWs9__"